import axios from "axios";
import { serverUrl } from "../../../../ApiRoute";

export const plantVolumeDump = async (dateRange) => {
    try {
        let res = await axios.post(`${serverUrl.sub}/v3/rdc/data/withDateRange`,dateRange);
        if (res.data.success) {
           let volumeData = res?.data?.data?.reduce((acc, dayData) => {
                let date =  dayData?.requestBody?.date_entry
                let data = dayData?.requestBody?.plant_volume || []
                acc[date] = data.reduce((acc,item)=>{
                    acc[item.plant_code] = item.volume
                    return acc
                },{})  
                return acc
                
            },{})
            return volumeData;
        } else {
            return {};
        }
    } catch (error) {
        return {};
    }
}
    